var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.529,
    height: 24.529,
    viewBox: "0 0 24.529 24.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 24.529,
    height: 24.529,
    transform: "translate(-3 -3)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_345",
    "data-name": "Groupe 345",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_340",
    "data-name": "Groupe 340",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_457",
    "data-name": "Trac\\xE9 457",
    d: "M13.567,22.133a8.567,8.567,0,1,1,8.567-8.567,8.576,8.576,0,0,1-8.567,8.567",
    transform: "translate(-4.302 -4.301)",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_458",
    "data-name": "Trac\\xE9 458",
    d: "M9.265,1.4A7.869,7.869,0,1,1,1.4,9.265,7.878,7.878,0,0,1,9.265,1.4m0-1.4a9.265,9.265,0,1,0,9.265,9.265A9.275,9.275,0,0,0,9.265,0",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_459",
    "data-name": "Trac\\xE9 459",
    d: "M23.462,30.424a6.962,6.962,0,1,1,6.962-6.962,6.97,6.97,0,0,1-6.962,6.962",
    transform: "translate(-14.197 -14.197)",
    fill: "#ffdf00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_460",
    "data-name": "Trac\\xE9 460",
    d: "M17.869,11.814a6.055,6.055,0,1,1-6.055,6.055,6.061,6.061,0,0,1,6.055-6.055m0-1.814a7.869,7.869,0,1,0,7.869,7.869A7.878,7.878,0,0,0,17.869,10",
    transform: "translate(-8.604 -8.604)",
    fill: "#fbb03b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.f390320c8af5058dd956538cd4ee3861.svg";
export { ForwardRef as ReactComponent };